/* eslint-disable */
export default {
  Inbound: 'In entrata',
  Outbound: 'In uscita',
  log: 'Registro',
  save: 'Salva e crea nuovo',
  discard: 'Elimina e crea nuovo',
  hangup: 'Riaggancia',
  reject: 'Alla segreteria telefonica',
  saveDraftAndCreateNewLog: 'Salva la bozza e crea un nuovo registro chiamate',
} as const;

// @key: @#@"Inbound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"Outbound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save and new"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard and new"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hangup"@#@
// @key: @#@"reject"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"saveDraftAndCreateNewLog"@#@ @source: @#@"Save draft and create new call log"@#@
